<template>
    <div id="newHelp">
      <div class="onGlobalization d_flex">
        <div></div>
        <div class="loginInfo">
          <ul>
            <li>
              <div><img src="../../assets/Avatar01.png" width="100%"/></div>
              <div style="height: 60px;padding-top: 20px" class="p_r c_p SapDivTop">
                <p class="m_b_5">123</p>
                <div style="color: #999999">
                  <p>123</p>
                  <!--<p style="width: 100px" v-else>-->
                  <!--  <marquee  direction="left">-->
                  <!--    123-->
                  <!--  </marquee>-->
                  <!--</p>-->
                </div>
                <section class="SapDiv">
                  <p @click="allPaswd()">修改密码</p>
                  <p @click="loginOut">退出系统</p>
                </section>
              </div>
            </li>
<!--            <li>-->
<!--              <span>退出</span>-->
<!--            </li>-->
          </ul>
        </div>
<!--        <span style="width: auto;vertical-align: initial;"></span>-->
<!--        <abbr><a @click="showDownLoadFile = true"><i class="icon iconfont iconyonghushouce m_r_5 colorRed" style="font-size: 20px"></i>{{$t('leftMenu.UserManual')}}</a></abbr>-->
<!--        <abbr @click="allSwitchLang()">-->
<!--          <i v-if="newSwitch === 'zh-CN'" class="icon iconfont iconzhongwen m_r_5 colorRed" style="font-size: 22px"></i>-->
<!--          <i v-else class="icon iconfont iconzhongwen1 m_r_5 colorRed" style="font-size: 22px"></i>-->
<!--          {{$t('leftMenu.Language')}}</abbr>-->
      </div>
      <model v-if="showModel" :onButton="3" :title="'修改密码'" :minWidth="'30%'" v-on:on-cancel="showModel = false" v-on:on-confirm="modefiyConfirm()">
        <div style="padding: 10px 40px">
          <div class="loginInfoDiv" >
            <ul>
              <li>
                <span class="required">旧密码</span>
                <div style="vertical-align: baseline">
                  <p v-if="errorModel" class="m_b_5"><span style="color: #FF0C1B">旧密码输入错误,请重新输入或</span><span @click="showForget = true" class="colorBlue4A85E8 c_p">找回密码</span></p>
                  <input v-model="modefiyPasswordModel.oldPassword" type="password" class="allInput" placeholder="请输入旧密码">
                </div>
              </li>
              <li>
                <span class="required">新密码</span>
                <div>
                  <p><span></span></p>
                  <input v-model="modefiyPasswordModel.newPassword" type="password" class="allInput" placeholder="请输入新密码">
                </div>
              </li>
              <li>
                <span class="required" style="margin-top: 5px">确定新密码</span>
                <div style="vertical-align: top">
                  <input v-model="modefiyPasswordModel.confirmPassword" type="password" class="allInput" placeholder="请输入新密码">
                  <p class="m_t_10 colorGray959595" style="text-align: justify">
                    注：长度不少于8个字符；至少包含：1.数字(0-9)，2小写字母(a-2)，3.大写字母(A-Z)；最近10次密码不能相同。
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </model>
      <model v-if="showForget" :onButton="3" :title="'忘记密码'" :minWidth="'30%'" v-on:on-cancel="showForget = false" v-on:on-confirm="forgetEmailFun()">
        <div style="padding: 10px 40px">
          <div class="allBodyInput" style="margin:40px auto">
            <dl>
              <dd style="margin: 0">
                <span class="required t_r" style="width: auto">邮箱</span>
                <div style="width: calc(100% - 67px)">
                  <input v-model="forgetEmail" type="text" class="allInput" placeholder="请输入邮箱" style="border: 1px solid #4A85E8">
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </model>
    </div>
</template>

<script>
export default {
  name: 'newHelp',
  data () {
    return {
      newSwitch: window.localStorage.getItem('language') === 'zh-CN' ? 'en-US' : 'zh-CN',
      showDownLoadFile: false,
      showForget: false,
      errorModel: false,
      showModel: false,
      forgetEmail: '',
      modefiyPasswordModel: {
        userID: window.localStorage.getItem('contentUserId'),
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      roleInfo: ''
    }
  },
  created () {
    // this.$axiox.get('/api/AccuralPeriod/UserManualFiles')
  },
  mounted () {
    // if (this.$userName.roleNameList) {
    //   this.roleInfo = this.$userName.roleNameList.join(',')
    // }
    // console.log(this.$userName.roleNameList)
  },
  methods: {
    forgetEmailFun () {
      if (this.forgetEmail !== '') {
        if (this.$commonJs.returnDigit(this.forgetEmail, 'email', '请输入正确的邮箱地址')) {
          this.forgetEmail = ''
          return
        }
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误:',
          content: '邮箱不能为空',
          stayTime: 5
        })
        return
      }
      let data = {
        email: this.forgetEmail
      }
      this.$axiox.post('/api/BackendUser/ForgetPassword', data, 1).then(p => {
        this.$commonJs.doubleComfirm({
          content: '重置密码已发送到用户邮箱,邮件中的链接只有24小时有效。',
          successFun: msg => {
          },
          errorFun: msg => {
          }
        })
      })
    },
    allPaswd () {
      this.showModel = true
      this.modefiyPasswordModel = {
        userID: window.localStorage.getItem('contentUserId'),
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },
    modefiyConfirm () {
      if (this.$commonJs.checkIfEmpty(this.modefiyPasswordModel, ['oldPassword', 'newPassword', 'confirmPassword'])) {
        return
      }
      if (this.modefiyPasswordModel.newPassword !== this.modefiyPasswordModel.confirmPassword) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误:',
          content: '两次密码不一致',
          stayTime: 5
        })
        return
      }
      if (/^(((?=.*[a-z])(?=.*[A-Z])(?=.*\d)))(?=.{8,})/.test(this.modefiyPasswordModel.confirmPassword)) {
        this.$axiox.post('/api/BackendUser/ChangePassword', this.modefiyPasswordModel, 1).then(p => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '重置密码成功',
            stayTime: 5
          })
          this.$router.push({
            name: 'login'
          })
        }).catch(p => {
          if (p.message === '旧密码不正确') {
            this.errorModel = true
          }
        })
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '请检查密码',
          content: '密码不符合规则',
          stayTime: 5
        })
      }
    },
    loginOut () {
      this.$commonJs.doubleComfirm({
        content: '是否需要退出？',
        successFun: msg => {
          window.localStorage.removeItem('contentToken')
          this.$router.push({
            name: 'login'
          })
        },
        errorFun: msg => {
        }
      })
    },
    allSwitchLang () {
      if (this.newSwitch === 'zh-CN') {
        window.localStorage.setItem('language', 'zh-CN')
      } else {
        window.localStorage.setItem('language', 'en-US')
      }
      window.location.reload()
    }
  }
}
</script>

<style scoped>
  .onGlobalization{
    /*width: calc(100% - 250px);*/
    background-color: #FDFDFD;
    padding: 0 20px;
    height: 60px;
    text-align: right;
  }
  .loginInfo {}
  .loginInfo ul li {
    display: inline-block;
    line-height: normal;
  }
  .loginInfo ul li:first-child {
    /*margin-right: 10px;*/
    /*border-right: 1px solid #CCD0E5;*/
    /*padding-right: 10px;*/
  }
  .loginInfo ul li:first-child > div {
    display: inline-block;
  }
  .loginInfo ul li:first-child > div:first-child {
    width: 7%;
    border-radius: 100%;
    margin-right: 10px;
  }
  .loginInfo ul li:first-child > div:first-child > img {
   border-radius: 100%;
  }
  .loginInfo ul li:first-child > div:last-child {
    vertical-align: middle;
    text-align: center;
  }
  .loginInfoDiv ul li > span {
    width: 80px;
  }
  .SapDiv {
    width: 100px;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 0 5px 1px #7D7D7D;
    position: absolute;
    top: 66px;
    right: 0;
    transition: all 0.5s;
    display: none;
  }
  .SapDiv > p {
    padding: 10px 20px;
    z-index: 10;
    cursor: pointer;
  }
  .SapDiv > p:first-child {
    border-radius: 5px 5px 0 0;
  }
  .SapDiv > p:last-child {
    border-radius:  0 0 5px 5px;
  }
  .SapDiv > p:hover {
    background-color: #F1F2F8;
    color: #408DEB;
  }
  .SapDivTop:hover .SapDiv {
    display: inline-block;
  }
  .SapDivTop:hover .SapDiv:hover {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/newHelp.vue